import { MatPaginatorIntl } from "@angular/material/paginator";

/**
 * Função que retorna uma instância de MatPaginatorIntl configurada para o idioma português.
 * Referência: https://v16.material.angular.dev/components/paginator/api#MatPaginatorIntl
 * @returns {MatPaginatorIntl} Instância de MatPaginatorIntl com rótulos traduzidos.
 */
export function getPaginatorIntl(): MatPaginatorIntl {
    const paginatorIntl = new MatPaginatorIntl();

    paginatorIntl.itemsPerPageLabel = "Itens por página:";
    paginatorIntl.nextPageLabel = "Próxima página";
    paginatorIntl.previousPageLabel = "Página anterior";
    paginatorIntl.firstPageLabel = "Primeira página";
    paginatorIntl.lastPageLabel = "Última página";

    paginatorIntl.getRangeLabel = (
        page: number,
        pageSize: number,
        length: number
    ) => {
        if (length === 0 || pageSize === 0) {
            return `0 de ${length}`;
        }

        const startIndex = page * pageSize;
        const endIndex =
            startIndex < length
                ? Math.min(startIndex + pageSize, length)
                : startIndex + pageSize;

        return `${startIndex + 1} – ${endIndex} de ${length}`;
    };

    return paginatorIntl;
}
